import { useRefreshActivitySummaryTable } from '@user/features/Activity/hooks/useRefreshActivitySummaryTable'
import { useCallback } from 'react'
import { deleteActivityEffect } from '@user/features/Activity/effects'

type Props = {
  onClose: () => void
  id: number
}

export function useHandlers(props: Props) {
  const { refetch } = useRefreshActivitySummaryTable()

  const { onClose, id } = props

  const onClick = useCallback(async () => {
    await deleteActivityEffect(id)
    await refetch()
    onClose()
  }, [onClose, id, refetch])

  return {
    onClick,
  }
}
